import { useState, useEffect } from "react";
import { LoadingIcon } from "../../assets/icons";
import { getChannelStatus } from "../../service/query/auth";

const StatusBadge = ({ status }) => {
  const isActive = status === "Active";
  const isNoData = status === "No recent data";
  const style = isActive
    ? "bg-[#E7F7EF] text-[#0E9F6E]"
    : isNoData
      ? "bg-[#F3F4F6] text-[#6B7280]"
      : "bg-[#FDECEC] text-[#E02424]";

  return (
    <span className={`inline-flex items-center gap-1 px-[10px] py-[3px] rounded-full text-[12px] font-medium ${style}`}>
      <span className="w-[6px] h-[6px] rounded-full bg-current" />
      {status ?? "-"}
    </span>
  );
};

export default function TransactionChannels() {
  const [channels, setChannels] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchChannels = async () => {
      try {
        const res = await getChannelStatus();

        // console.log("Channel API Full Payload:", res);
        // console.log("Channel API Data Array:", res?.data?.data);

        setChannels(res?.data?.data ?? []);
      } catch (err) {
        console.error("Error fetching channel status:", err);
      } finally {
        setLoading(false);
      }
    };
    fetchChannels();
  }, []);

  return (
    <div className="p-6 bg-white min-h-[80vh]">
      {loading ? (
        <div className="flex justify-center py-10">
          <LoadingIcon />
        </div>
      ) : (
        <div className="rounded-md overflow-hidden">
          <div className="overflow-x-auto">
            <table className="w-full text-sm text-left">
              <thead className="bg-[#F8FAFC] h-[44px]">
                <tr>
                  <th className="px-4 py-3 text-black text-[12px] font-semibold border-b whitespace-nowrap">Transaction Channel ↓</th>
                  <th className="px-4 py-3 text-black text-[12px] font-semibold border-b whitespace-nowrap">Transaction Count ↓</th>
                  <th className="px-4 py-3 text-black text-[12px] font-semibold border-b whitespace-nowrap">Failures Today ↓</th>
                  <th className="px-4 py-3 text-black text-[12px] font-semibold border-b whitespace-nowrap">Last Seen ↓</th>
                  <th className="px-4 py-3 text-black text-[12px] font-semibold border-b whitespace-nowrap">Status ↓</th>
                </tr>
              </thead>
              <tbody>
                {channels.length === 0 ? (
                  <tr>
                    <td colSpan={5} className="text-center py-10 text-gray-400">
                      No channel data available
                    </td>
                  </tr>
                ) : (
                  channels.map((ch, idx) => (
                    <tr key={ch.channel || idx} className="border-b h-[70px] hover:bg-blue-50 transition-colors">
                      <td className="px-4 py-3 text-[#64748B] text-[14px]">{ch.channel ?? "-"}</td>
                      <td className="px-4 py-3 text-[#64748B] text-[14px]">{ch.total_today ?? 0}</td>
                      <td className="px-4 py-3 text-[#64748B] text-[14px]">{ch.failures_today ?? 0}</td>
                      <td className="px-4 py-3 text-[#64748B] text-[14px]">{ch.last_seen ?? "-"}</td>
                      <td className="px-4 py-3">
                        <StatusBadge status={ch.status} />
                      </td>
                    </tr>
                  ))
                )}
              </tbody>
            </table>
          </div>
        </div>
      )}
    </div>
  );
}